module.exports = __webpack_public_path__ + "img/dick_slide_1.db8b4419.jpg";